// redux/store.js
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import themeReducer from "./Slices/themeSlice";
import authSlice from "./Slices/authSlice";
import employeeSlice from "./Slices/employeeSlice";
import roleSlice from "./Slices/roleSlice";
import projectSlice from "./Slices/projectSlice";
import taskSlice from "./Slices/taskSlice";
import leaveSlice from "./Slices/leaveSlice";
import leaveApproveSlice from "./Slices/leaveApproveSlice";
import dashboardSlice from './Slices/dashboardSlice'
import attendanceSlice from "./Slices/attendanceSlice";

const reducer = combineReducers({
  auth: authSlice,
  theme: themeReducer,
  employee: employeeSlice,
  role: roleSlice,
  project: projectSlice,
  task: taskSlice,
  leave: leaveSlice,
  leaveAprrove: leaveApproveSlice,
  dashboard: dashboardSlice,
  attendance: attendanceSlice
})

const store = configureStore({
  reducer: reducer
});

const getStore = () => {
  return store;
};


export { store, getStore };